module.exports = __webpack_public_path__ + "media/scholarship_winners/marci-sw-e8867d78.png";